var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24.347 24.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_522",
    "data-name": "\\u7EC4 522",
    transform: "translate(-139.755 -3460.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_250",
    "data-name": "\\u8DEF\\u5F84 250",
    d: "M151.218,3460.86h1.426c.322.038.643.071.964.116a12.178,12.178,0,0,1,10.307,9.96c.079.457.125.92.187,1.381v1.426a1.8,1.8,0,0,0-.042.228,11.581,11.581,0,0,1-.677,3.193,12.174,12.174,0,0,1-23.408-6.417,12.181,12.181,0,0,1,9.859-9.7C150.292,3460.968,150.757,3460.921,151.218,3460.86Zm.216,13.792c-.288.034-.579.049-.862.1a8.521,8.521,0,0,0-6.556,5.2.33.33,0,0,0,.086.429,10.757,10.757,0,0,0,15.689-.031.3.3,0,0,0,.067-.372,8.537,8.537,0,0,0-1.12-1.951,8.422,8.422,0,0,0-5.071-3.192c-.407-.085-.822-.132-1.261-.2a4.2,4.2,0,1,0-.972.018Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManFilled);
export default __webpack_public_path__ + "static/media/user_man_filled.1cda8768355037850c6b5f0ef0390079.svg";
export { ForwardRef as ReactComponent };